import {
  calculateTimetableSchedules,
  TimetableScheduleBlock,
  TimetableScheduleBlockInput,
  TimetableScheduleNormalizationError,
  // Deep import avoids @weareopenr/common's top-level barrel, which also re-exports its zod
  // codecs - those ship .d.cts files using TS 5 syntax this project's TS 4.9 can't parse.
} from '@weareopenr/common/build/src/validationHelper/timetable-schedule';
import { ITimetableSchedule } from 'src/api/getTimetable';
import { getEntityRef, getScheduleTrack, TimetableEntityRef, TimetableScheduleTrack, toEntityFields } from './helpers';

export type RemoveScheduleResult =
  | { success: true; blocks: TimetableScheduleBlock[] }
  | { success: false; error: TimetableScheduleNormalizationError };

// Resends only the (day, track) lanes containing a removed slot, with those slots handed to the
// default; calculateTimetableSchedules merges the result with neighbouring default blocks.
export const reassignToDefault = (
  existingSchedules: ITimetableSchedule[],
  track: TimetableScheduleTrack,
  isRemoved: (schedule: ITimetableSchedule) => boolean,
  defaultEntity: TimetableEntityRef,
): RemoveScheduleResult => {
  const trackSchedules = existingSchedules.filter((schedule) => getScheduleTrack(schedule) === track);
  const affectedDays = new Set(trackSchedules.filter(isRemoved).map((schedule) => schedule.day_of_week));

  const blocks: TimetableScheduleBlockInput[] = trackSchedules
    .filter((schedule) => affectedDays.has(schedule.day_of_week))
    .map((schedule) => {
      const entity = isRemoved(schedule) ? defaultEntity : getEntityRef(schedule);
      return {
        day_of_week: schedule.day_of_week,
        start_time: schedule.start_time,
        end_time: schedule.end_time,
        ...toEntityFields(entity),
      };
    });

  const result = calculateTimetableSchedules(blocks);
  if (result.success === false) return result;

  return { success: true, blocks: result.schedules.flatMap((group) => group.blocks) };
};
